import ReactGA from 'react-ga4';
import { trackMetaPageView } from './metaPixel';

export function trackScreenView(page, title) {
  if (process.env.NODE_ENV !== 'production') return;
  ReactGA.send({ hitType: 'pageview', page, title });
  // SPA route changes don't reload the document, so re-fire the Meta Pixel PageView.
  trackMetaPageView();
}
